{
  "register-pin-page": {
    "buttons": {
      "resend": "Renvoyer",
      "submit": "Soumettre"
    },
    "text": {
      "email-check": "CONSEILS : Veuillez également vérifier votre dossier spam ou vérifier si votre email <strong>{{ email }}</strong> est correct ou utilisez un email différent pour l'inscription !",
      "in-second": "en {{seconds}} s",
      "not-receive-pin": "Vous n'avez pas reçu de code PIN ?",
      "pin-incorrect": "Le code PIN est incorrect. Veuillez le vérifier dans votre e-mail et réessayer.",
      "verify-account": "Vérifier votre compte",
      "verify-account-hint": "L'épingle de confirmation sera envoyée à votre adresse électronique <strong>{{ email }}</strong>."
    }
  }
}
